import { X } from "@phosphor-icons/react";
import classes from "./Modal.module.css";
import { Modal } from "react-bootstrap";

type Props = {
  isOpen: boolean;
  handleClose: any;
  title?: any;
  subtitle?: any;
  width?: string;
  height?: string;
  maxHeight?: string;
  maxWidth?: string;
  footer?: JSX.Element;
  style?: any;
  showCloseIcon?: boolean;
  closeIconSize?: number;
  headerColor?: string;
  /* ── Header "detalhe" do design system (opcional) ──────────────
     Com headerVariant="detail" o header passa a ser alinhado à
     esquerda: mosaico de ícone + eyebrow + título grande + ações à
     direita. Sem esta prop nada muda no header centrado por omissão. */
  headerVariant?: "centered" | "detail";
  /* Conteúdo do mosaico 56x56 à esquerda do título (ex.: um ícone). */
  headerIcon?: JSX.Element;
  /* Linha em maiúsculas acima do título (ex.: "Detalhes · Secção · Grupo"). */
  eyebrow?: any;
  /* Elemento à direita do título, alinhado pela baseline (ex.: um chip). */
  titleAside?: JSX.Element;
  /* Ações à direita do header, antes do botão de fechar. */
  headerActions?: JSX.Element;
  /* Aplica o canto superior esquerdo de 24px e a sombra de modal do DS. */
  notch?: boolean;
  /* Linha a fechar o header. Nos modais com tabs o divisor vem por baixo
     destas, por isso só é preciso onde não existem tabs. */
  headerDivider?: boolean;
  /* Linha a separar o rodapé do conteúdo. */
  footerDivider?: boolean;
  /* Classe extra no corpo do modal, para quem precisa de outro padding. */
  bodyClassName?: string;
};

const CustomModal: React.FC<Props> = ({
  isOpen,
  handleClose,
  title,
  subtitle,
  children,
  width,
  height,
  maxHeight,
  maxWidth,
  footer,
  style,
  showCloseIcon = 1,
  closeIconSize = 22,
  headerColor,
  headerVariant = "centered",
  headerIcon,
  eyebrow,
  titleAside,
  headerActions,
  notch = false,
  headerDivider = false,
  footerDivider = false,
  bodyClassName,
}) => {
  const isDetail = headerVariant === "detail";

  return (
    <Modal
      style={style}
      show={isOpen}
      onHide={handleClose}
      container={document.body}
      contentClassName={notch ? classes.modal_notch : undefined}
    >
      <Modal.Header
        className={`${classes.modal_header} ${
          isDetail ? classes.modal_header_detail : ""
        } ${headerDivider ? classes.modal_header_divider : ""}`}
        style={{ backgroundColor: headerColor }}
      >
        {isDetail ? (
          <div className={classes.detail_header}>
            {headerIcon ? (
              <span className={classes.detail_icon}>{headerIcon}</span>
            ) : null}

            <div className={classes.detail_heading}>
              {eyebrow ? (
                <span className={classes.detail_eyebrow}>{eyebrow}</span>
              ) : null}
              <div className={classes.detail_title_row}>
                <span className={classes.detail_title}>{title}</span>
                {titleAside}
              </div>
              {subtitle ? (
                <div className={classes.detail_subtitle}>{subtitle}</div>
              ) : null}
            </div>

            <div className={classes.detail_actions}>
              {headerActions}
              {showCloseIcon ? (
                <button
                  type="button"
                  className={classes.detail_close}
                  onClick={() => handleClose()}
                  aria-label="Fechar"
                >
                  <X size={20} />
                </button>
              ) : null}
            </div>
          </div>
        ) : (
          <>
            <div className="col-12 d-flex justify-content-between">
              <span style={{ width: "22px", marginRight: "1.25rem" }}></span>
              <span className={classes.modal_title}>{title}</span>

              <span className={classes.modal_close}>
                {showCloseIcon ? (
                  <X onClick={() => handleClose()} size={closeIconSize} />
                ) : null}
              </span>
            </div>
            <div>
              {subtitle ? (
                <>
                  {typeof subtitle == "string" ? (
                    <h5 className={classes.modal_subtitle}>{subtitle}</h5>
                  ) : (
                    <div className={classes.modal_subtitle}>{subtitle}</div>
                  )}{" "}
                </>
              ) : null}
            </div>
          </>
        )}
      </Modal.Header>
      <Modal.Body
        className={`${classes.modal_body} ${bodyClassName || ""}`}
        style={{
          maxHeight: maxHeight || "",
          maxWidth: maxWidth || "",
          height: height || "",
          width: width || "",
          overflow: style?.overflow || "",
        }}
      >
        {children}
      </Modal.Body>
      {footer ? (
        <Modal.Footer
          className={`${classes.modal_footer} ${
            footerDivider ? classes.modal_footer_divider : ""
          }`}
        >
          {footer}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};

export default CustomModal;
